/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Device Package - Android WebView (@accedo/xdk-device-android-webview) 4.2.3
* 
*******************************************************************************/
import{detection as detect}from"@accedo/xdk-core";const detection=detect((e=>e.toLowerCase().includes("xdkandroidwebview")));export default detection;